module.exports = __webpack_public_path__ + "img/Airbnb-Productivity-Hacks-Multitasking-Myth.7b24c01e.png";